import React, { useEffect } from "react";

import { useAppContext } from "../../../hooks/useAppContext";
import { showDialogAsync } from "../../dialog-queue";

import { IFrameDialog } from "../../dialog/iframe/iframe-dialog";

interface IPartnerImport {
	storeType: eXpress.core.StoreType;
	selection: eXpress.core.IPartnerPhoto[];
}

interface ISmartphotoImport {
	selection: eXpress.IImportedPhotoWithDateAsString[] | eXpress.IImportedPhoto[];
}

// we don't control this type, it's what we receive from web iframe
type IFrameImportPhotosResult = IPartnerImport | ISmartphotoImport | null;

type ImportPhotosResult = Exclude<IFrameImportPhotosResult, null>["selection"];

const ImportPhotosDialog = ({
	open,
	onClose,
	storeKey,
}: {
	open: boolean;
	onClose(importResult: ImportPhotosResult | undefined): void;
	/** Undefined for smartphoto */
	storeKey: string | undefined;
}) => {
	const {
		context: { homeUrl, photoSelectionUrl = "/importphotos" },
	} = useAppContext();

	useEffect(() => {
		const onImportFinished = ((event: CustomEvent<IFrameImportPhotosResult>) => {
			onClose(event.detail?.selection);
		}) as EventListener;

		document.addEventListener("importPhotosFinished", onImportFinished);

		const onCloseClicked = (event: any) => {
			if (!event.data || event.data.command !== "CloseImportPhotosPopUp") return;

			onClose(undefined); // close the popup
		};
		// iframe with loginpopup has its own close icon that triggers a message with command: 'CloseImportPhotosPopUp'
		window.addEventListener("message", onCloseClicked);

		return () => {
			document.removeEventListener("importPhotosFinished", onImportFinished);
			window.removeEventListener("message", onCloseClicked);
		};
	}, [onClose]);

	const url = `${homeUrl.endsWith("/") ? homeUrl.slice(0, -1) : homeUrl}/${
		photoSelectionUrl.startsWith("/") ? photoSelectionUrl.slice(1) : photoSelectionUrl
	}?embed&store=${storeKey ?? "eXpress"}&pagesize=60}`;
	return <IFrameDialog isOpen={open} url={url} iframeTitle="importphoto" />;
};
ImportPhotosDialog.displayName = "ImportPhotosDialog";

/**
 * Show photo selection dialog for a specific store
 */
export const showImportPhotosDialogAsync = ({ storeKey }: { storeKey: string | undefined }) =>
	showDialogAsync<ImportPhotosResult>(({ resolve }, { isOpen }) => (
		<ImportPhotosDialog storeKey={storeKey} open={isOpen} onClose={resolve} />
	));
